import React, { useState } from 'react';

import { Box } from '@mui/material';

import OrderSearchForm, { MultiFilterState } from '~/components/Common/Forms/OrderSearchForm';

import LuxPlusPage from './LuxPlusPage';

function LuxPlusPageContainer() {
  const [filterField, setFilterField] = useState<string>('');
  const [filterValue, setFilterValue] = useState<string>('');
  const [additionalSearchParams, setAdditionalSearchParams] = useState<MultiFilterState>(null);
  // bumped on every submit so repeating an identical search still refetches
  const [searchNonce, setSearchNonce] = useState(0);

  const handleSearchQuery = (field, value) => {
    setFilterField(field);
    setFilterValue(value);
    setSearchNonce((nonce) => nonce + 1);
  };

  return (
    <Box>
      <OrderSearchForm
        bookingIdType={null}
        hideReferenceNumberFilter
        searchQuery={handleSearchQuery}
        setAdditionalParams={setAdditionalSearchParams}
      />
      <LuxPlusPage
        filterField={filterField}
        filterValue={filterValue}
        additionalSearchParams={additionalSearchParams}
        searchNonce={searchNonce}
      />
    </Box>
  );
}

export default LuxPlusPageContainer;
